@if (countdownClockData) {
    <div class="campaign-countdown-clock-wrapper">
        @if (countdownClockData?.bgItems) {
            <finder-lottie-bg
                [data]="countdownClockData.bgItems"
                [onTriggerPlayback]="triggerPlayback"
            ></finder-lottie-bg>
        }

        @if (targetMatch) {
            <finder-countdown-clock
                [countdownClockData]="countdownClockData"
                [ngClass]="cssClass"
                (clockVisible)="clockVisible($event)"
            ></finder-countdown-clock>
        }
    </div>
}
